import errAnnouceApi from 'api/errAnnouceApi'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import { default as ToastHelper } from 'general/helpers/ToastHelper'
import { default as Utils } from 'general/utils/Utils'

export const createErrAnnouce = async (
  company,
  invoiceIdsArray,
  submitAction,
  tableData,
  values,
  dispatch,
  setAppSpinning,
  navigate,
  signingConfig,
) => {
  try {
    const res = await errAnnouceApi.createAD({
      ...values,
      tableData,
    })
    if (res?.result === 'success') {
      ToastHelper.showSuccess('Lưu thông báo nháp thành công')
      // navigate('/hoa-don-dau-ra/xu-ly-hoa-don/danh-sach-thong-bao-sai-sot')
      switch (submitAction) {
        case 'Save': {
          navigate('/hoa-don-dau-ra/chung-tu-tncn/xu-ly-ct/thong-bao-lap-sai')
          break
        }
        case 'SaveAndSign': {
          let errorAnnoucementId = res.data?.errorAnnoucementId

          let { signingMethod } = signingConfig
          if (signingMethod == 'HSM') {
            try {
              await errAnnouceApi.hsmSignErrAnnouceDocument({
                errorAnnoucementId,
              })

              ToastHelper.showSuccess('Ký thông báo sai sót thành công')
              navigate(
                '/hoa-don-dau-ra/chung-tu-tncn/xu-ly-ct/thong-bao-lap-sai',
              )
            } catch (e) {
              navigate(
                `/hoa-don-dau-ra/chung-tu-tncn/xu-ly-ct/thong-bao-lap-sai/${errorAnnoucementId}`,
              )
            }
          } else {
            let accessToken = localStorage.getItem(PreferenceKeys.accessToken)
            const urlSchema = `${process.env.REACT_APP_BASE_URL_SCHEMA}${accessToken},message300,${errorAnnoucementId},${company?.taxCode}`
            Utils.openToolSignErrAnnouce(
              urlSchema,
              accessToken,
              dispatch,
              setAppSpinning,
              navigate,
            )
          }

          break
        }
        default:
          return
      }
    }
  } catch (err) {
    console.log(err)
  } finally {
    dispatch(setAppSpinning(false))
  }
}
